"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
var package_1 = require("../../package");
var constants_1 = require("../constants");
var use_theme_1 = __importDefault(require("../hooks/use-theme"));
var tailwind_1 = __importDefault(require("../utils/tailwind"));
var provider_select_1 = require("./provider-select");
function priorityToText(priority) {
  switch (priority) {
    case constants_1.Priorities.Recent:
      return 'Recent';
    case constants_1.Priorities.Popular:
      return 'Popular';
    case constants_1.Priorities.Default:
    default:
      return 'More';
  }
}
var styles = (0, tailwind_1.default)({
  spacer: "tw-h-10",
  title: "\n    tw-pb-2\n    tw-text-md\n    tw-font-medium\n    tw-sticky\n    tw-top-0\n    tw-z-10\n    ",
  verticalContainer: "\n    tw-flex\n    tw-flex-col\n    tw-overflow-hidden\n    tw-h-full\n    ".concat(react_device_detect_1.isMobile ? 'tw-gap-y-4' : 'tw-gap-y-1', "\n    ").concat(react_device_detect_1.isMobile ? 'tw-w-80' : 'tw-w-48', "\n    ").concat(react_device_detect_1.isMobile ? 'md:tw-w-96' : 'md:tw-w-64'),
  scrollableList: "\n    tw-flex\n    tw-flex-col\n    tw-overflow-y-auto\n    tw-overflow-x-hidden\n    tw-overscroll-contain\n    tw-pr-1",
  subtitle: "\n    tw-font-medium\n    tw-text-sm\n    tw-pb-6",
  flexColumn: "\n    tw-flex\n    tw-flex-col",
  columnFooter: "\n    tw-flex\n    tw-sticky\n    ".concat(react_device_detect_1.isMobile ? 'tw-py-4' : 'tw-pt-4', "\n    ").concat(react_device_detect_1.isMobile ? '' : 'tw-bottom-0', "\n    ").concat(react_device_detect_1.isMobile ? 'tw-justify-center' : 'tw-justify-end', "\n    tw-gap-x-2"),
  columnSearchableFooter: "\n    tw-justify-between\n    ",
  version: "\n    tw-text-xs\n    tw-leading-5\n    tw-font-mono\n    tw-font-thin\n    tw-self-end",
  noMatchesContainer: "\n    tw-h-full\n    tw-flex\n    tw-flex-col\n    tw-items-center\n    tw-justify-center",
  container: "\n    tw-flex-grow",
  noMatchesSpan: "\n    tw-font-normal\n    tw-align-center",
  inputContainer: "\n    tw-flex\n    tw-self-end",
  input: "\n    tw-text-sm\n    tw-font-medium\n    placeholder:tw-font-medium\n    placeholder:tw-text-current\n    placeholder:tw-text-align-end\n    focus-visible:tw-outline-none\n    "
  // todo: figure out a way to handle the placeholder color with the theme
});

function Tray(_ref) {
  var providersByPriority = _ref.providers,
    title = _ref.title,
    onClickProvider = _ref.onClickProvider,
    selectedProvider = _ref.selectedProvider,
    search = _ref.search,
    onSearch = _ref.onSearch;
  var theme = (0, use_theme_1.default)();
  var nPriorities = providersByPriority.reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
      prio = _ref3[0];
    if (!acc.includes(prio)) acc.push(prio);
    return acc;
  }, []);
  var searchElem = (0, react_1.useMemo)(function () {
    return react_1.default.createElement("div", {
      className: "".concat(styles.columnFooter, " ").concat(onSearch ? styles.columnSearchableFooter : ''),
      style: {
        background: theme.background
      }
    }, onSearch && react_1.default.createElement("div", {
      className: styles.inputContainer
    }, react_1.default.createElement("input", {
      className: styles.input,
      style: {
        background: theme.background,
        color: theme.textTertiary
      },
      placeholder: "Search for a wallet",
      value: search || '',
      onChange: function onChange(event) {
        var _a;
        return onSearch((_a = event.target) === null || _a === void 0 ? void 0 : _a.value);
      }
    })), react_1.default.createElement("span", {
      className: styles.version,
      style: {
        color: theme.muted
      }
    }, package_1.version));
  }, [theme, search, onSearch]);
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: styles.verticalContainer
  }, react_1.default.createElement("div", {
    className: "".concat(styles.scrollableList, " rc-tray-ios-fix")
  }, react_1.default.createElement("div", {
    className: styles.title,
    style: {
      color: theme.textSecondary,
      background: theme.background
    }
  }, react_1.default.createElement("h1", null, title), react_device_detect_1.isMobile && searchElem), !providersByPriority.length && react_1.default.createElement("div", {
    className: styles.noMatchesContainer
  }, react_1.default.createElement("span", {
    className: styles.noMatchesSpan,
    style: {
      color: theme.textTertiary
    }
  }, "No matches")), providersByPriority.map(function (_ref4, i) {
    var _ref5 = _slicedToArray(_ref4, 2),
      priority = _ref5[0],
      providers = _ref5[1];
    return react_1.default.createElement("div", {
      key: priority,
      className: nPriorities.length === 1 || i > 0 ? styles.container : ''
    }, !react_device_detect_1.isMobile && nPriorities.length !== 1 && react_1.default.createElement("span", {
      className: styles.subtitle,
      style: {
        color: theme.textSecondary
      }
    }, priorityToText(priority)), react_1.default.createElement("div", {
      className: styles.verticalContainer
    }, providers.map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        providerKey = _ref7[0],
        provider = _ref7[1];
      return react_1.default.createElement(provider_select_1.ProviderSelect, {
        key: providerKey,
        provider: provider,
        selected: provider.name === selectedProvider,
        onClick: function onClick() {
          return onClickProvider(providerKey);
        }
      });
    }), react_device_detect_1.isMobile && react_1.default.createElement("span", {
      className: styles.spacer
    })));
  }), !react_device_detect_1.isMobile && searchElem)));
}
exports.default = Tray;